import React from "react";
import { Tooltip } from "./Tooltip";
import { Shield } from "lucide-react";

export const InfluencerBrandSafety = ({ userDatas }) => {
  return (
    <div className="mb-5">
      {/* Header */}
      <header className="mb-5 ml-5">
        <div className="w-full mx-auto flex gap-2 ">
          <h1 className="text-3xl font-bold text-gray-900">
            Brand Safety Analysis
          </h1>
        </div>
      </header>

      {/* Main Content */}
      <main className="w-full mx-auto mb-8  px-4 sm:px-6">
        {/* Hero Section */}
        <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl border border-green-200 shadow-lg hover:shadow-xl transition-all duration-300 p-3 sm:p-8 mb-5 !pt-5">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
            <div className="flex-1 mb-6 lg:mb-0 lg:pr-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">
                Discover Instagram's brand safety report
              </h2>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                Collaborations with Instagram can elevate your brand but come
                with risks. Our brand safety report helps you make informed
                decisions by analyzing Instagram's content history and detecting
                potential red flags.
              </p>

              <div className="relative inline-block">
                <button
                  className="!bg-purple-800 text-white py-2 px-4 rounded-lg !hover:bg-purple-700 transition duration-200 font-bold"
                  disabled // Optional: disables the button
                >
                  Get full report for $199
                </button>
                <span className="absolute -top-3 right-0 bg-gradient-to-r from-green-500 to-black text-white text-xs font-semibold px-3 py-1 rounded-full shadow-lg">
                  Coming Soon
                </span>
              </div>
              <p className="text-sm text-gray-500 italic mt-5">
                Your customized report will be ready within 3-4 hours.
              </p>
              <p className="text-sm text-gray-500 mt-5">
                These scores are calculated based on the influencer's last 10
                posts captions. To access detailed insights and a full analysis,
                unlock the complete report.
              </p>
            </div>

            {/* Visual Elements */}
            <div className="flex-shrink-0 p-4">
              <img src={`${process.env.PUBLIC_URL}/images/brandSeafty.png`} />
            </div>
          </div>
        </div>

        {/* Analysis Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-5">
          {Array.isArray(userDatas?.sentiment_comment) &&
            userDatas.sentiment_comment.length > 0 && (
              <div className="bg-white rounded-2xl border border-green-200 shadow-lg hover:shadow-xl transition-all duration-300 p-2 sm:p-3">
                <div className="flex items-center flex-wrap mb-1 sm:mb-1">
                  <span className="text-lg sm:text-2xl mr-2 sm:mr-3">😊</span>
                  <h3 className="text-base sm:text-xl font-semibold text-gray-900">
                    Mostly positive
                  </h3>
                </div>
                <div className="space-y-1">
                  {userDatas?.sentiment_comment?.map((sentiment, i) => (
                    <div
                      className="flex items-center flex-wrap mb-0.5 pl-4"
                      key={i}
                    >
                      <span className="mr-1">&bull;</span>

                      <span className="text-base sm:text-lg mr-1 sm:mr-2">
                        "
                      </span>
                      <div className="flex">{sentiment.content}</div>
                      <span className="text-base sm:text-lg ml-1 sm:ml-2">
                        "
                      </span>
                    </div>
                  ))}
                </div>
                <div className="mt-2 sm:mt-3 mb-1 sm:mb-2 border-gray-100">
                  <div className="flex items-center text-gray-500">
                    <span className="text-xs sm:text-sm">
                      Comments sentiment analysis
                    </span>
                    <Tooltip
                      description={
                        "We use NLP to analyze comment sentiment on recent influencer posts, revealing how audiences truly feel and engage."
                      }
                    />
                  </div>
                </div>
              </div>
            )}

          {/* <div className="bg-white border border-gray-50 hover:shadow-md transition-shadow duration-200 rounded-lg shadow-sm p-3 sm:p-4 flex flex-col h-full">
          Top Section 

            <div className="flex items-center mb-3">
              <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center mr-3">
                <svg
                  className="w-5 h-5 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900">
                No issues found
              </h3>
            </div>

            {/* Spacer to push the analysis to the bottom
            <div className="flex-1" />

            {/* Bottom Section 
            <div className="pt-2 mt-auto mb-2 sm:mb-3">
              <div className="flex items-center text-gray-500">
                <span className="text-sm">Brand safety analysis</span>
                <Tooltip
                  description={
                    "We leverage NLP to scan an influencer’s recent posts and videos for potential brand risk. If any issues are detected, we flag them with a clear, actionable report."
                  }
                />
              </div>
            </div>
          </div> */}
          <div className="bg-white rounded-2xl border border-green-200 shadow-lg hover:shadow-xl transition-all duration-300 p-3 sm:p-4 flex flex-col h-full">
            <div className="flex items-center mb-3">
              <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center mr-3">
                <svg
                  className="w-5 h-5 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900">
                No issues found
              </h3>
            </div>

            <div className="flex-1" />

            <div className="pt-2 mt-auto mb-2 sm:mb-3">
              <div className="flex items-center text-gray-500">
                <span className="text-sm">Brand safety analysis</span>
                <Tooltip
                  description={
                    "We leverage NLP to scan an influencer's recent posts and videos for potential brand risk. If any issues are detected, we flag them with a clear, actionable report."
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};
